import React from 'react'
import { View } from 'react-native'
import { TouchableOpacity } from 'react-native-gesture-handler'
import Animated, { FadeInLeft } from 'react-native-reanimated'

import ChipPinkMaroon from '../../components/ANewDesign/assets/ChipsPinkMaroon.svg'
import { DS } from '../../design-system'
import { useStore } from '../../models'

import { router } from 'expo-router'

import { Avatar } from "@/screens/profile-screen/edit/AvatarBuilder"

interface IPlayerNameProps {
  onEditPress: () => void
}


export const PlayerName: React.FC<IPlayerNameProps> = ({ onEditPress }) => {
  const {
    session: { user }
  } = useStore()
  const username = user?.name?.slice(0, 15) ?? ''

  function onEditProfilePress(){
    router.navigate({ pathname: '/(root)/editProfile' }) 
  }


  return (
    <Animated.View entering={FadeInLeft} pointerEvents="box-none" style={{ flexDirection: "row", alignItems: "center", gap: DS.spacing[12], paddingBottom: DS.spacing[16] }}>
      <Avatar size={50} />
      {/*<ChipPinkMaroon height={32} width={32} style={{ alignSelf: 'center' }} />*/}
      <View pointerEvents="box-none" style={{ flexShrink: 1 }}>
        <DS.Text numberOfLines={1} color="Global/White" variant="Heading 2/Regular">
          {username}
        </DS.Text>
        <TouchableOpacity onPress={onEditProfilePress} hitSlop={10}>
          <DS.Text variant="Body Small/Regular" color="Global/White">
            Edit Profile
          </DS.Text>
        </TouchableOpacity>
      </View>
    </Animated.View>
  )
}
